module.exports = __webpack_public_path__ + "static/media/tpc_world_boatsail.27573174.svg";